
import React from 'react';

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time:"",
            Days:"",
            Week:""
        }
    }

    componentDidMount() {
        // 获取实时系统时间
        this.inteval =  setInterval(() =>this.setState({time:this.times(new Date().getTime())}),1000);
    }

    componentWillUnmount() {
        clearInterval(this.inteval);
    }

    // 当前实时时间
    times=() =>{
        let date = new Date();
        let year = date.getFullYear() + '-';
        let month = (date.getMonth() + 1 < 10 ? "0"+(date.getMonth()+1) : date.getMonth() + 1 ) + '-';
        let day = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + ' ';
        let hour = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ':';
        let min = (date.getMinutes() < 10 ? "0"+ date.getMinutes() : date.getMinutes()) + ':';
        let sec = (date.getSeconds() < 10 ? "0"+ date.getSeconds() : date.getSeconds());
        let Days = year + month + day ;
        let days = date.getDay();
        let weeks = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]
        let Week = weeks[days];
        this.setState({
            Days,
            Week
        })
        let strDate =  hour + min + sec;
        return strDate;
    }

    render() {
        const {time,Days,Week} = this.state;
        return (
            <div style={{width:"18%",color:'#fff',margin:"25px 0",position:"absolute",top:"0px",right:"0px",letterSpacing:"2px",textAlign:'center'}}>
                <span style={{color:"#2ffdff",fontWeight:"bold"}}>{Days}</span>
                <span style={{color:"#2ffdff",padding:"0px 20px",fontWeight:"bold"}}>{Week}</span>
                <span style={{color:"#2ffdff",fontSize:"22px"}}>{time}</span>
               
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./containers/Show/_TopTime.js